/**
 * The "logical button" comparison presets (Yesterday → Today, Last week → This week, …).
 * Selecting one sets both ranges atomically; editing a range elsewhere flips this to Custom.
 * For Media Devoted | Created By Ciro Autiero
 */

import { cn } from '@/lib/utils';

import { COMPARE_PRESETS, type ComparePresetCode } from '../../state/comparePresets';

interface Props {
  active: ComparePresetCode;
  onSelect: (code: ComparePresetCode) => void;
}

export function ComparePresetBar({ active, onSelect }: Props) {
  return (
    <div className="flex flex-wrap gap-1.5" role="radiogroup" aria-label="Comparison preset">
      {COMPARE_PRESETS.map((preset) => {
        const selected = preset.code === active;
        return (
          <button
            key={preset.code}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onSelect(preset.code)}
            className={cn(
              'rounded-full border px-3 py-1 text-xs font-medium transition-colors',
              selected
                ? 'border-primary bg-primary/10 text-foreground ring-2 ring-primary/25'
                : 'border-border bg-muted/30 text-muted-foreground hover:bg-muted/50 hover:text-foreground',
            )}
          >
            {preset.label}
          </button>
        );
      })}
    </div>
  );
}

export default ComparePresetBar;
